import { useEffect, useSyncExternalStore } from 'react';
import * as memosApi from '../api/memos';

// How many live memos from HQ the agent has not read — the badge on More →
// Memos and on the desktop sidebar. One shared count for the whole app: the
// pop-up and the Memos page call refreshMemoUnread() after a memo is read, and
// every badge follows.
let count = 0;
let inFlight = null;
const listeners = new Set();
const emit = () => listeners.forEach((fn) => fn());

export function refreshMemoUnread() {
  if (!inFlight) {
    inFlight = memosApi.getUnreadCount()
      .then((r) => { count = Number((r?.data ?? r)?.unread) || 0; emit(); })
      .catch(() => {})
      .finally(() => { inFlight = null; });
  }
  return inFlight;
}

const subscribe = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export default function useMemoUnread() {
  useEffect(() => { refreshMemoUnread(); }, []);
  return useSyncExternalStore(subscribe, () => count);
}
